<template>
    <div class="accordion-item">
        <h2 class="accordion-header" id="mass-shipments">
            <button class="accordion-button" type="button" @click="$helper.toggleAccordion(2, true);">
                {{ $helper.trans('Filling_address_list_') }}
            </button>       
        </h2>
        <div id="mass-shipments-content" class="accordion-collapse collapse" aria-labelledby="mass-shipments" data-parent="#mass-shipments-parent">
            <label class="new-address mt-3">
                {{ $helper.trans('Please_download_shipments_template') }}:
            </label>
            <div class="accordion-body pt-0">
                <div class="row w-100">
                    <div class="col-12">
                        <a :href="$store.state.$routes['download_batch_file']">
                            <img src="/images/mass-shipments-template.jpg" alt="excel">
                        </a>
                    </div>  
                    <div class="col-12 mt-5">
                        <div class="option-content full-width option-upload-content">
                            <div class="w-100 upload-style uploadedFiles_MassShipmentsAttachments_input">
                                <div class="form-file">
                                    <div id="mass_shipments_attachment_dropzone" class="my-dropzone upload-field" style="height: 250px;">
                                        <div class="dropzone-panel mb-lg-0 mb-2">
                                            <span class="icon-upload"></span>
                                            <span class="title-upload">{{ $helper.trans('Upload_files_here') }}</span>
                                            <span class="or">{{ $helper.trans('Or') }}</span>
                                            <label class="btn btn-upload dropzone-select">{{ $helper.trans('Select_from_device') }}</label>
                                        </div>
                                        <div class="dropzone-items wm-200px"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> 
                    <div class="col-12 mt-3">
                        <div class="d-flex justify-content-center align-items-center" v-if="$store.state.currentActions.gettingShippingOptions">
                            {{ $helper.trans('Search_for_services') }}
                            <i class="fa fa-cog fa-spin fa-2x ml-2"></i>
                        </div>
                    </div>
                    <div class="col-12 mt-5" v-show="$store.state.massShipments.length > 0">
                        <div class="custom-table">
                            <div class="table-wrap">
                                <div class="table-head">
                                    <div class="table-tr" style="padding: 15px 0 0 15px;">
                                        <div class="table-td" style="width:20%;justify-content: flex-start;max-width: 150px;">
                                            {{ $helper.trans('Address') }}
                                        </div>
                                        <div class="table-td" style="width:10%;justify-content: flex-start;max-width: 150px;">
                                            {{ $helper.trans('City') }}
                                        </div>
                                        <div class="table-td" style="width:10%;justify-content: flex-start;max-width: 150px;">
                                            {{ $helper.trans('Zip_code') }}
                                        </div>
                                        <div class="table-td" style="width:10%;justify-content: flex-start;max-width: 150px;">
                                            {{ $helper.trans('Country') }}
                                        </div>
                                        <div class="table-td" style="width:15%;justify-content: flex-start;max-width: 150px;">
                                            {{ $helper.trans('Service') }}
                                        </div>
                                        <div class="table-td" style="width:30%;justify-content: flex-start;max-width: 150px;">
                                            {{ $helper.trans('Latest_collection_time') }}
                                        </div>
                                        <div class="table-td" style="width:30%;justify-content: flex-start;max-width: 150px;">
                                            {{ $helper.trans('Estimated_delivery') }}
                                        </div>
                                        <div class="table-td" style="width:12%;justify-content: flex-start;max-width: 150px;">
                                            {{ $helper.trans('With_warranty') }}
                                            <i class="fa fa-question-circle info-question-circle position-absolute" style="margin-top: -5;">
                                                <div class="custom-popover-wrapper">
                                                    <div class="custom-popover alert alert-secondary" v-html="$helper.trans('Guaranteed_indicator_info')">
                                                    </div>
                                                </div>
                                            </i>
                                        </div>
                                        <div class="table-td" style="width:10%;">{{ $helper.trans('Price') }}</div>
                                    </div>
                                </div>
                                <mass-shipments-form></mass-shipments-form>
                            </div>
                        </div>                        
                    </div>              
                </div>
                <div class="link-block">
                    <button type="button" @click="$helper.toggleAccordion(1, true);" class="link link-left">{{ $helper.trans('Shipping_address') }}</button>
                    <button type="button" @click="nextStep();" class="link link-right">{{ $helper.trans('Shipment_information') }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import store from "../../../store";
export default {
    store,
    created: function () {
        let vueThis = this;

        vueThis.$nextTick(function () {
            let template = `<div class="dropzone-item"><div class="dropzone-file"><div class="dropzone-filename" title="some_image_file_name.jpg"><span data-dz-name>some_image_file_name.jpg</span><strong>(<span data-dz-size>340kb</span>)</strong></div><div class="dropzone-error" data-dz-errormessage></div></div><div class="dropzone-progress"><div class="progress"><div class="progress-bar bg-primary" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0" data-dz-uploadprogress></div></div></div><div class="dropzone-toolbar"><span class="dropzone-delete" data-dz-remove><i class="bi bi-x fs-1"></i></span></div></div>`;

            vueThis.dropzone = new window.Dropzone('#mass_shipments_attachment_dropzone', {
                url: vueThis.$store.state.$routes['upload_mass_shipments'],
                headers: {
                    'x-csrf-token': $('meta[name="csrf-token"]').attr('content')
                },
                init: function () {
                    this.on("sending", function(file, xhr, formData) {
                        vueThis.$store.state.currentActions.gettingShippingOptions = true;
                        formData.append('city', vueThis.$store.state.shipperAddressInformation.city);                   
                        formData.append('postCode', vueThis.$store.state.from.postCode);
                        formData.append('country', vueThis.$store.state.from.country);    
                    });
                    this.on('success', function (file, response) {
                        $.each(response, function (index, element) {      
                            vueThis.$store.state.massShipments.push(element);
                        });          
                        
                        vueThis.$store.state.currentActions.gettingShippingOptions = false;
                        setTimeout(function() {
                            vueThis.checkErrors(vueThis.$store.state.massShipments);
                        }, 500);
                    });
                },
                previewTemplate: template,
                previewsContainer: '#mass_shipments_attachment_dropzone .dropzone-items',
                clickable: '#mass_shipments_attachment_dropzone .dropzone-select',
                addRemoveLinks: true,           
                acceptedFiles: '.xlsx',
                maxFiles: 1,
                removedfile: function (file) {
                    $(file.previewElement).remove();
                    vueThis.$store.state.massShipments = [];
                },
            });

            vueThis.dropzone.on('totaluploadprogress', function (progress) {
                $('#mass_shipments_attachment_dropzone').find('.progress-bar').each(function (index, element) {
                    $(element).css({ 'width': `${progress}%` });
                });
            });
        });      
    },
    methods: {
        nextStep() {     
            this.$store.state.currentLevel = 2;          
            this.$helper.toggleAccordion(5, true);            
        },
        checkErrors(shipments) {
            let vueThis = this;      
        
            $.each(shipments, function (blockId, shipment) {           
                if (shipment.service.status !== 200) {
                    $(`.block_${blockId}`).addClass('alert-danger-ups');
                    shipment.show = true;
                    $.each(shipment.service.errors, function (errorKey, errors) {                
                        let inputName = `.${errorKey.replaceAll('.', '_')}_input`;     
                        inputName = inputName.replaceAll('to_country_input', 'to_country_mass_input');                    
    
                        let input = $(`.block_${blockId}_input`).find(inputName);
                      
                        if (input.length > 0) {                    
                            $(input).addClass('alert-danger-ups');  
                            $.each(errors, function (index, errorText) {                        
                                $(input).first().parent().append(`<span class="ups-danger-text ml-3">${errorText}</span>`);                              
                            });
                        } else {   
                            if (errors.length > 0) {    
                                $.each(errors, function(index, errorText) {
                                    showToast(errorText, "#c91a13", 30000);
                                });
                            }
                        }

                        if (vueThis.$store.state.$siteSettings['debug']) {
                            console.log(inputName);
                        }
                    });
                }
            });
        },   
    },
}
</script>